import { OrganizationSubscriptionStatus } from './subscription';

export interface Organization {
  organizationId: string;
  name: string;
  ownerEmail?: string;
  ownersNames?: string;
  ownersEmails?: string;
  status?: OrganizationStatus;
  createdAt: Date;
  lastUpdatedAt: Date;
  showAsSubcontractor: boolean;
  atavEnabled?: boolean;
  // When true, the invoicing page is paused for this org (SUPER_ADMIN toggle)
  invoicingPaused?: boolean;
  // Sprint 12, story-052 (U72). WARN lets a tech complete/submit-for-approval past an
  // unsatisfied required evidence slot; BLOCK disables the transition until every required slot
  // is satisfied. SUPER_ADMIN toggle, same modal as atavEnabled/invoicingPaused.
  completenessGateMode?: CompletenessGateMode;
  // Sprint 33, story-167. Daily site report org schedule (D6). Null timezone => disabled for
  // this organization.
  dailyReportTimezone?: string | null;
  dailyReportSendHour?: number;
  // Subscription fields for SUPER_ADMIN organization list
  subscriptionId?: string;
  subscriptionStatus?: OrganizationSubscriptionStatus | null;
  planName?: string;
  planId?: string;
  trialEndsAt?: string | null;
  trialExpiredAt?: string | null;
  billingPeriod?: string | null;
  // Billing presence only (booleans). The API never returns card data here.
  hasNmiSubscription?: boolean;
  hasPaymentMethod?: boolean;
}

export enum OrganizationStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  SUSPENDED = 'SUSPENDED',
}

/** Sprint 12, story-052 (U72). */
export enum CompletenessGateMode {
  WARN = 'WARN',
  BLOCK = 'BLOCK',
}

export interface getOrganizationsRequest {
  getOrganizations: {
    organizations: Organization[];
    count: number;
  };
}

export interface getOrganizationsForTaskCreationRequest {
  getOrganizationsForTaskCreation: {
    organizations: Organization[];
    count: number;
  };
}

export interface getOrganizationRequest {
  getOrganization: Organization;
}

export interface createOrUpdateOrganizationRequest {
  createOrganization?: Organization;
  updateOrganization?: Organization;
}

export interface disableOrEnableOrganizationRequest {
  disableOrganization?: Organization;
  enableOrganization?: Organization;
}

export interface SubcontractorProject {
  projectId: string;
  name: string;
  address?: string;
  startDate?: string;
  endDate?: string;
  budget?: number;
  state?: string;
  originalProjectId?: string;
}

export interface Subcontractor {
  organizationId: string;
  name: string;
  status?: OrganizationStatus;
  showAsSubcontractor: boolean;
  projects: SubcontractorProject[];
}

export interface getSubcontractorsRequest {
  getSubcontractors: Subcontractor[];
}
